/**
 * LA LISTA MASTER DE PERSONAS (SUJ-T3, ASSIGN #17005 orden 4).
 *
 * AUDIENCIA: el admin de plataforma (Josse), en escritorio. Decision de Ares en spec-persona-v1:
 * "master" es el rol admin de plataforma; no existe un rol llamado master. El API la sirve solo
 * a ese rol (GET /api/v1/personas?estado=active, paginada, forma resumida sin asistencia ni
 * capacitacion por fila); el panel la esconde a los demas con la audiencia 'nexo'.
 *
 * Cada fila se lee con leerPersona (la misma regla de la ficha): nunca un campo de PIN.
 *
 * Sin DOM: lo prueba scripts/check-personas-master.mjs.
 */

import { leerPersona, lineasDeLaPersona } from './fichaDePersona.js';

const lista = (v) => (Array.isArray(v) ? v : []);

/** { personas, total } desde la respuesta de ApiBase; personas ya normalizadas. */
export function leerListaMaster(res) {
  if (!res || !res.ok) return { personas: [], total: 0 };
  const cuerpo = res.data || {};
  const d = cuerpo.data !== undefined ? cuerpo.data : cuerpo;
  const filas = Array.isArray(d) ? d : lista(d?.items);
  const personas = filas.map((f) => leerPersona({ ok: true, data: f })).filter(Boolean);
  const total = Number.isFinite(Number(d?.total)) ? Number(d.total) : personas.length;
  return { personas, total };
}

/** Por que no hay lista, segun la causa (misma distincion de los dos 404 que la ficha). */
export function porQueNoHayLista(res) {
  if (!res) return { motivo: 'RED', frase: 'No pudimos hablar con la API.' };
  if (res.ok) return null;
  if (res.code === 404 && !res.details) {
    return { motivo: 'NO_PUBLICADO', frase: 'La lista de personas se enciende sola cuando la API la publique (SUJ-T1).' };
  }
  if (res.code === 403) return { motivo: 'PERMISO', frase: 'Esta lista es solo para el administrador de la plataforma.' };
  return { motivo: 'RED', frase: String(res.error || 'No pudimos hablar con la API.') };
}

/** Filtra por nombre o negocio, sin tildes ni mayusculas. */
export function filtrarPersonas(personas, texto) {
  const norm = (s) => String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const q = norm(texto);
  if (!q) return lista(personas);
  return lista(personas).filter((p) => norm(p.nombre).includes(q) || p.membresias.some((m) => norm(m.negocio).includes(q)));
}

/**
 * PANEL-SUJETOS-LISTA-T1 punto 3: la ficha del negocio enlaza a #/personas?q=<negocio> y la lista abre ya filtrada.
 * Lee q del hash (decodificado); '' si no viene o no se puede leer.
 */
export function busquedaDeLaRuta(hash) {
  const i = String(hash ?? '').indexOf('?');
  if (i < 0) return '';
  try { return (new URLSearchParams(String(hash).slice(i + 1)).get('q') || '').trim(); } catch { return ''; }
}

/** El enlace de la ficha de un negocio a sus personas (mismo filtro que el buscador: por nombre del negocio). */
export function rutaPersonasDelNegocio(nombreNegocio) {
  const n = String(nombreNegocio ?? '').trim();
  return n ? `#/personas?q=${encodeURIComponent(n)}` : '#/personas';
}

/** Las celdas de una fila: [nombre, negocios, panel, operacion, nexos]. */
export function celdasDeLaFila(p) {
  const l = Object.fromEntries(lineasDeLaPersona(p));
  return [p.nombre, l['Negocios'], l['Entra al panel'], l['Operación'], l['Nexos']];
}
